import type {
  ISaveSearchSubmitEvent,
  ISaveSearchSubmitInput,
} from '../types/clickEvents';

const saveSearchSubmit = (
  input: ISaveSearchSubmitInput,
): Omit<ISaveSearchSubmitEvent, 'event'> => ({
  linkDetails: input.linkDetails,
});

export default saveSearchSubmit;
